import { Injectable } from "@angular/core";
import { CargoItem } from "../../models/cargo-item.interface";
import { ShippingBill } from "../../models/shipping-bill.interface";



@Injectable({
    providedIn: 'root'
})
export class CargoService {

    public transformToShippingBill(item: CargoItem): ShippingBill {
        const metadata = item.exportCargoMetadata;

        const shippingBill: ShippingBill = {
            id: item.id,
            documentNo: item.documentNo,
            shippingBillDate: metadata?.shippingBillDate!,
            freightForwarder: item.accountHolder!,
            cha: item.cha,
            exporter: item.exporter!,
            pol: item.portOfLoading!,
            pod: item.portOfDestination,
            finalPod: item.finalPortOfDestination,
            commodity: item.commodity!,
            packageType: item.packageType,
            nop: item.numberOfPackages,
            weight: item.grossWeight?.valueOf(),
            volume: item.grossVolume?.valueOf(),
            fobValue: metadata?.freightOnBoard?.valueOf(),
            coldStorage: item.coldStorage,
            hazardous: item.hazardous,
            imoCode: item.imoCode,
            unNo: item.unNo,
            marksAndNumbers: item.marksAndNumbers,
            sttNo: metadata?.sttNo,
            pcinNo: metadata?.pcimNo,
            cartingCommunication: metadata?.cartingCommunication,
            stuffingType: metadata?.stuffingType
        };

        return shippingBill;
        
    }


}